import React from 'react';
import Styled from './Footer.style';
import LinkHandler from '../../LinkHandler';
import * as _ from 'lodash';
import { Icon } from '@savewatersavemoney/swsm-ui';
import { AppConfig } from '../../../interfaces';
import { Grid, Row, Col } from 'react-styled-flexboxgrid';
import { renderCdnUrl } from '../../../helpers';
import { useTranslation } from 'react-i18next';

interface FooterProps {
  appWidth: number;
  appConfig: AppConfig;
  location: any;
}

const Footer: React.FC<FooterProps> = props => {
  const { appWidth, appConfig, location } = props;
  const { data } = appConfig;
  const [t] = useTranslation('common');

  if (!data || _.isEmpty(data)) {
    return null;
  }

  const { socialMedia } = data;
  const device = () => {
    if (appWidth > 1025) {
      return 'desktop';
    }
    if (appWidth > 600 && appWidth <= 1025) {
      return 'tablet';
    }
    return 'mobile';
  };

  const footerNav: any = _.filter(data.navElements, {
    location: 'footer',
  });

  const renderFooterLinks = () => {
    return _.map(footerNav, el => {
      return (
        <Col md={3} sm={6} xs={12} key={el.path}>
          <LinkHandler internal path={el.path}>
            {t(el.name)}
          </LinkHandler>
        </Col>
      );
    });
  };

  const facebook = _.get(socialMedia, 'facebook');
  const twitter = _.get(socialMedia, 'twitter');
  const youtube = _.get(socialMedia, 'youtube');
  const instagram = _.get(socialMedia, 'instagram');

  return (
    <div
      data-test="footer"
      style={
        location.pathname === '/' || location.pathname === '/india'
          ? {
            backgroundColor: '#0b2641',
            marginTop: '0px',
          }
          : {
            backgroundColor: '#0b2641',
            marginTop: '32px',
          }
      }
    >
      <Grid>
        <Styled.Wrap layout={device()}>
          <Styled.Image>
            <img src={renderCdnUrl('logos/www-white.svg')} alt="GetWaterFit" />
          </Styled.Image>
          <Styled.FooterTop>
            <Row>{renderFooterLinks()}</Row>
          </Styled.FooterTop>
          <Styled.Line />
          <Styled.FooterBottom>
            <Styled.TextWrap>
              <Styled.TextFirst>{t('portal.footer.copyright_pretext')}</Styled.TextFirst>
              <div style={{ fontSize: '12px' }}>{t('portal.footer.copyright')}</div>
            </Styled.TextWrap>

            {facebook || twitter || youtube || instagram ? (
              <Styled.SocialMedia>
                {facebook ? (
                  <LinkHandler label="Facebook link" path={facebook}>
                    <Styled.IconWrap>
                      <Icon icon="facebook" size={16} />
                    </Styled.IconWrap>
                  </LinkHandler>
                ) : null}
                {twitter ? (
                  <LinkHandler label="Twitter link" path={twitter}>
                    <Styled.IconWrap>
                      <Icon icon="twitter" size={16} />
                    </Styled.IconWrap>
                  </LinkHandler>
                ) : null}
                {youtube ? (
                  <LinkHandler label="Youtube link" path={youtube}>
                    <Styled.IconWrap>
                      <Icon icon="youtube" size={20} />
                    </Styled.IconWrap>
                  </LinkHandler>
                ) : null}
                {instagram ? (
                  <LinkHandler label="Instagram link" path={instagram}>
                    <Styled.IconWrap>
                      <Icon icon="instagram" size={20} />
                    </Styled.IconWrap>
                  </LinkHandler>
                ) : null}
              </Styled.SocialMedia>
            ) : null}
          </Styled.FooterBottom>
        </Styled.Wrap>
      </Grid>
    </div>
  );
};

export default Footer;
